import { z } from 'zod';
import { EVENTS } from '../events.js';
const EVENT_TYPES = Object.values(EVENTS);
/** docs/architecture/08-v1-scope.md § "Webhooks & API". An empty
 * `eventTypes` array subscribes to every event type. */
export const createWebhookSubscriptionSchema = z.object({
    url: z.string().url(),
    description: z.string().trim().max(200).optional(),
    eventTypes: z.array(z.enum(EVENT_TYPES)).default([]),
    enabled: z.boolean().default(true),
});
export const updateWebhookSubscriptionSchema = createWebhookSubscriptionSchema.partial();
/** Real numbers over the last 7 days of deliveries, not decoration
 * (design/orion-crm-design/rendered-html/AdminWebhooks.html's "99.8% · 7
 * days" / "Last 3 deliveries returned 500"). `null` fields mean there's
 * nothing recent enough to summarize yet. */
export const webhookHealthSchema = z.object({
    status: z.enum(['healthy', 'failing', 'unknown']),
    successRatePct: z.number().nullable(),
    recentFailureSummary: z.string().nullable(),
});
export const webhookSubscriptionResponseSchema = z.object({
    id: z.string().uuid(),
    url: z.string(),
    description: z.string().nullable(),
    eventTypes: z.array(z.string()),
    enabled: z.boolean(),
    disabledAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
    health: webhookHealthSchema,
});
/** Returned exactly once — on create or regenerate — never recoverable
 * afterward (same convention as ApiKey). */
export const webhookSubscriptionWithSecretResponseSchema = webhookSubscriptionResponseSchema.extend({
    secret: z.string(),
});
export const webhookDeliveryResponseSchema = z.object({
    id: z.string().uuid(),
    eventType: z.string(),
    status: z.enum(['pending', 'delivered', 'failed']),
    attempt: z.number().int(),
    responseStatus: z.number().int().nullable(),
    error: z.string().nullable(),
    nextAttemptAt: z.string().datetime().nullable(),
    deliveredAt: z.string().datetime().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=webhooks.js.map